import { Dialog, DialogTitle, DialogContent, DialogActions, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import DownloadReferenceList from './DownloadReferenceList';

// Read-only dialog listing every reference (citations only — no links, no notes).
// Scrolls when the list is long. Download/copy at the bottom-left mirrors the
// References panel via the shared DownloadReferenceList.
const ViewListModal = ({ open, handleClose, references = [] }) => (
  <Dialog open={open} onClose={handleClose} fullWidth maxWidth="md">
    <DialogTitle sx={{ fontSize: '26px', fontWeight: 700, textAlign: 'left' }}>
      Reference List
      <IconButton
        aria-label="close"
        onClick={handleClose}
        sx={{ position: 'absolute', right: 18, top: 18, color: '#000' }}
      >
        <CloseIcon />
      </IconButton>
    </DialogTitle>

    <DialogContent sx={{ textAlign: 'left', color: '#000' }}>
      {references.map((reference) => (
        <p key={reference._id} style={{ marginTop: 0, marginBottom: '14px', lineHeight: 1.4 }}>
          {reference.reference}
        </p>
      ))}
    </DialogContent>

    <DialogActions sx={{ justifyContent: 'flex-start', px: 3, py: 2 }}>
      <DownloadReferenceList references={references} />
    </DialogActions>
  </Dialog>
);

export default ViewListModal;
